import { MenuItem, Select } from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { ApiUrl } from "../../../utils/ApiUrl";

interface ICustomDestinationField {
  scheduleId: number | null;
  disabled: boolean;
  input: string;
  setInput: (x: string) => void;
  setHotelAddress: (x: string) => void;
  id: string;
  name: string;
  error: any;
  helperText: any;
  editState: boolean;
}

const CustomDestinationField = ({
  scheduleId,
  disabled,
  id,
  name,
  setInput,
  setHotelAddress,
  input,
  error,
  editState,
}: ICustomDestinationField) => {
  var customParseFormat = require("dayjs/plugin/customParseFormat");
  dayjs.extend(customParseFormat);
  const [destinationList, setDestinationList] = useState([]);

  const GetDestinationList = () => {
    return axios
      .request({
        method: "GET",
        url: `${ApiUrl}/scheduleDestinations/`,

        params: {
          PageNumber: 1,
          PageSize: 9999,
        },

        // headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("destination list", res);
        setDestinationList(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    GetDestinationList();
    !editState && setInput("");
  }, [scheduleId]);

  return (
    <Select
      displayEmpty
      disabled={disabled}
      id={id}
      name={name}
      value={input}
      onChange={(event) => {
        setInput(event.target.value);
        destinationList.find((items: any) => {
          console.log(items, event.target.value);
          if (items.destination === event.target.value) {
            setHotelAddress(items.hotelAddress);
          }
        });
      }}
      MenuProps={{
        style: {
          maxHeight: 300,
        },
      }}
      size="small"
      error={error}
    >
      <MenuItem disabled value="">
        <p className="text-[#a9a9a9]">Select Destination</p>
      </MenuItem>
      {destinationList.map((item: any) => (
        <MenuItem key={item.id} value={item.destination}>
          {item.destination}
        </MenuItem>
      ))}
    </Select>
  );
};

export default CustomDestinationField;
